module.exports = __webpack_public_path__ + "img/2-5.cf8dd075.jpg";